import React, { ReactElement, useState } from 'react';
import styles from './ExpandableText.module.less';
import { Tooltip } from 'antd';
import Hoverable from './Hoverable';

export type ExpandableTextProps = {
    collapsedText?: string;
    expandedText?: string;
};

function ExpandableText({
    collapsedText,
    expandedText,
}: ExpandableTextProps): ReactElement {
    const [expanded, setExpanded] = useState(false);

    const handleClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Hoverable>
            <Tooltip
                placement="bottom"
                title="Click to switch display mode."
                className={styles.ExpandableText}
                {...{
                    onClick: handleClick,
                }}
            >
                {expanded ? (
                    <span>{expandedText}</span>
                ) : (
                    <span>{collapsedText}</span>
                )}
            </Tooltip>
        </Hoverable>
    );
}

export default ExpandableText;
